import { render, staticRenderFns } from "./metadata-editor.vue?vue&type=template&id=16426b8e&"
import script from "./metadata-editor.vue?vue&type=script&lang=js&"
export * from "./metadata-editor.vue?vue&type=script&lang=js&"
import style0 from "./metadata-editor.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports